import React from "react";
import { IFormField } from "types/gaiaComponents/formField";

export const FormField = (props: React.PropsWithChildren<IFormField>) => {
    // Clone child and add disabled prop if props.disabled is true, and always add id
    // Only clone if children is a valid React element
    const childWithProps = React.isValidElement(props.children)
        ? React.cloneElement(props.children, {
            disabled: props.disabled || props.children.props.disabled,
            id: props.id
        } as any)
        : props.children;

    return (
        <div className="ga-form-field mb-16 mr-2">
            {props.label &&
                <label
                    className={`ga-form-field__label${props.labelDefined ? ' ga-form-field__label--defined' : ''}${props.disabled ? ' ga-form-field__label--disabled' : ''}`}
                    htmlFor={props.id}
                    tabIndex={props.tabIndexLabel}
                >
                    <span className="ga-form-field__label-text">{props.label}</span>
                    {props.labelState && (
                        <span className="ga-form-field__label-state"> {props.labelState}</span>
                    )}
                </label>
            }
            {childWithProps}
            {props.info &&
                <div className={`ga-form-field__info${props.info.type ? ` ga-form-field__info--${props.info.type}` : ''}`}>
                    {props.info.icon && <span className="ga-form-field__info-icon">{props.info.icon}</span>}
                    {props.info.label}
                </div>
            }
        </div>
    );
};
